import { useMemo } from 'react'
import {
  getPoiApplicationId,
  getPoiRubricId,
  getReservationTemplatizeUrl
} from '../../store/geoentity/geoentity.accessors'
import { isEmpty } from '../../utils/lang'
import { TAG_PUBLISHER } from '../analytics/analytics.tagids.constants'
import { useSelector } from 'react-redux'
import { selectCurrentGeoentity } from '../../store/geoentity/geoentity.selectors'

const useCommonGeoentityPublisherTagProps = (tag, specificGeoentity) => {
  const currentGeoentity = useSelector(selectCurrentGeoentity)
  const geoentity = specificGeoentity ?? currentGeoentity
  const isReservable = !isEmpty(getReservationTemplatizeUrl(geoentity))

  return useMemo(
    () => ({
      tagInfo: {
        tag,
        Rubrique: getPoiRubricId(geoentity),
        Application: getPoiApplicationId(geoentity),
        Disponibilite: isReservable ? 'D' : 'ND'
      },
      type: TAG_PUBLISHER
    }),
    [tag, geoentity, isReservable]
  )
}

export default useCommonGeoentityPublisherTagProps
